import { Box } from "@mui/material";
import copy from "copy-to-clipboard";
import "react-toastify/dist/ReactToastify.css";
import { getRemoteValue } from "../../Utils/firebase";
import CToast from "../CToast/CToast";

interface Prop {
  text: string | number | undefined;
}
const CopyText = ({ text }: Prop) => {
  const textToCopy = text;

  const handleCopy = () => {
    const textToString = text?.toString();
    textToString && copy(textToString);
    CToast(getRemoteValue("copy_toast"), "success");
  };

  return (
    <div
      onClick={handleCopy}
      className="flex justify-between items-center"
      style={{
        cursor: "pointer",
      }}
    >
      <p
        style={{
          color: "#191B1E",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        {textToCopy}
      </p>
      <Box
        component="img"
        sx={{
          width: "20px",
          height: "20px",
          marginLeft: "8px",
        }}
        alt="colendi"
        src="/icons/copy-icon.svg"
      />
    </div>
  );
};

export default CopyText;
